import { LzAppConstants } from "./Constants";

export const lzSaveToLocalStorage = (key, data) => {
    // console.log('LS-Save', key, data);
    localStorage.setItem(
        LzAppConstants.app_code + '_' + key,
        JSON.stringify({ type: typeof data, value: data })
    );
};

export const lzGetFromLocalStorage = (key, defaultData) => {
    try {
        // Loads as json
        const data = localStorage.getItem(LzAppConstants.app_code + '_' + key);

        // If not found then send default data
        if (!data) {
            return defaultData;
        }

        // Else parse json
        const load = JSON.parse(data);

        // Return the saved value
        return load.value;
    } catch (e) {
        console.log('LocalStorage: ' + key, e.toString());
        return '';
    }
};
